// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
/* eslint-disable camelcase */

import { createAsyncAction } from 'typesafe-actions';
import { Progress } from '../../../types/Model';

export interface UpdateOnlineCourseProgressRequestPayload {
  id: number;
  progress: Progress;
  onSuccess: () => void;
}
export interface UpdateOnlineCourseProgressSuccessPayload {
  id: number;
  progress: Progress[];
}

export interface UpdateOnlineCourseProgressFailPayload {
  error: Error;
}

const updateOnlineCourseProgressActions = createAsyncAction(
  'elearning/UPDATE_ONLINE_COURSE_PROGRESS_REQUEST',
  'elearning/UPDATE_ONLINE_COURSE_PROGRESS_SUCCESS',
  'elearning/UPDATE_ONLINE_COURSE_PROGRESS_FAIL'
)<UpdateOnlineCourseProgressRequestPayload, UpdateOnlineCourseProgressSuccessPayload, UpdateOnlineCourseProgressFailPayload>();

export { updateOnlineCourseProgressActions as default };
